import { detect as detectBrowser } from 'detect-browser';


const parsedUserAgent = detectBrowser();

export default parsedUserAgent;
